<div class="popup-container">
    <div class="popup-header">
        <h3 class="m-0">Seleziona il Tour Nuovo</h3>
    </div>

    <div class="popup-body">
        <div class="mb-3">
            <label class="form-label fw-bold">Tour</label>

            <ng-select
                class="filter-ng-select filter-ng-select-tour"
                [items]="tours"
                bindLabel="tourRoutingCode"
                [formControl]="tourCtrl"
                [clearable]="true"
                [searchable]="true"
                [loading]="loading"
                appendTo="body"
                placeholder="Seleziona un tour"
                notFoundText="Nessun tour trovato"
                loadingText="Caricamento...">

                <ng-template ng-option-tmp let-item="item">
                    <span class="status-option">
                        <i class="fas fa-route me-2"></i>
                        <span>{{ getDisplay(item) }}</span>
                    </span>
                </ng-template>

                <ng-template ng-label-tmp let-item="item">
                    <span class="status-option">
                        <i class="fas fa-route me-2"></i>
                        <span>{{ getDisplay(item) }}</span>
                    </span>
                </ng-template>

            </ng-select>

            <div *ngIf="error" class="text-danger small mt-1">
                {{ error }}
            </div>
        </div>

        <div class="mb-3" *ngIf="carriers.length > 0">
            <label class="form-label fw-bold">Carrier</label>

            <ng-select
                class="filter-ng-select filter-ng-select-carrier"
                [items]="carriers"
                bindLabel="carrierName"
                bindValue="carrierCode"
                [formControl]="carrierCtrl"
                [clearable]="true"
                [searchable]="true"
                [searchFn]="searchCarrierFn"
                appendTo="body"
                placeholder="Seleziona un carrier"
                notFoundText="Nessun carrier trovato">

                <ng-template ng-option-tmp let-item="item">
                    <span class="status-option">
                        <i class="fas fa-truck me-2"></i>
                        <span>{{ item.carrierName || item.carrierCode }}</span>
                    </span>
                </ng-template>

                <ng-template ng-label-tmp let-item="item">
                    <span class="status-option">
                        <i class="fas fa-truck me-2"></i>
                        <span>{{ item.carrierName || item.carrierCode }}</span>
                    </span>
                </ng-template>

            </ng-select>
        </div>
    </div>

    <div class="popup-footer d-flex justify-content-between gap-2">
        <button type="button" class="btn btn-light" (click)="cancel()">
            <i class="fas fa-times me-2"></i>
            Annulla
        </button>

        <button
                type="button"
                class="btn btn-primary"
                [disabled]="tourCtrl.invalid || loading || loadingCarriers || (carriers.length > 0 && !carrierCtrl.value)"
                (click)="confirm()"
        >
            Avanti <i class="fas fa-arrow-right ms-2"></i>
        </button>
    </div>
</div>